import { render, staticRenderFns } from "./AdminClients.vue?vue&type=template&id=47e50318&scoped=true&"
import script from "./AdminClients.vue?vue&type=script&lang=ts&"
export * from "./AdminClients.vue?vue&type=script&lang=ts&"
import style0 from "./AdminClients.vue?vue&type=style&index=0&id=47e50318&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e50318",
  null
  
)

export default component.exports